import React, { useEffect } from 'react'
import HeroSlider from '../Components/slider/HeroSlider'
import ReportSlider from '../Components/slider/ReportSlider'
import NewsLetter from '../Components/slider/NewsLetter'
import { Link } from 'react-router-dom'
import Aos from 'aos'
import TwitterCompoent from '../Components/slider/TwitterCompoent'
import ParallaxSection from '../Components/ParallaxSection'

function Home() {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <div className='relative overflow-hidden hero-slider'>
        <HeroSlider />
      </div>
      <div className='bg-[#FFFFFF]'>
        <section
          // className="lg:px-[100px] px-[20px] bg-[#FFFFFF] overflow-hidden mt-[-6px] pt-[50px] lg:pt-[50px] pb-[50px] lg:pb-[50px]"
          className="lg:px-[100px] px-[20px] bg-[#FFFFFF] overflow-hidden mt-[-6px] pt-[80px] sm:pt-[90px] lg:pt-[100px] pb-[80px] sm:pb-[90px] lg:pb-[100px]"
          style={{
            background:
              "linear-gradient(180deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)",
          }}
        >
          <div className="max-w-[1440px] w-full mx-auto">

            <div
              className="w-full mx-auto bg-white rounded-[20px] lg:rounded-[30px] py-[30px] lg:py-[40px] px-[20px] lg:px-[30px]"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="grid grid-cols-1 lg:grid-cols-[30%_70%] gap-[20px] lg:gap-[48px] items-center">
                <div
                  className="flex justify-center items-center"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <img
                    // src="/assets/home/newmap.jpeg"
                    src="/assets/home/flag.avif"
                    className="h-[250px] lg:h-[250px] object-cover rounded-[16px] lg:rounded-[20px]"
                    alt="About Us"
                  />
                </div>
                <div
                  className="flex flex-col items-start"
                  style={{ paddingRight: "50px" }}
                  data-aos="fade-left"
                  data-aos-delay="300"
                >
                  {/* <div className='btn-header'>
                    <p>                  About Us
                    </p>
                  </div> */}
                  {/* <p className="py-[2px] px-[8px] bg-[#0F3460] font-neue font-[400] text-[10px] lg:text-[12px] leading-[12px] tracking-[1.44px] uppercase text-white">
                  About Us
                </p> */}
                  <p className="font-[400] font-neue text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#05003E] pb-[5px] lg:pb-[5px] mt-[20px]">
                    IndUS Tech is a commercial strategy firm advising companies and investors in U.S.-India defense, technology, and industry. We work with clients at every stage, from first market entry to acquisitions and new ventures in either country. Some retain us for the long term. Others engage us for a specific mandate. The firm was founded by Kriti Upadhyaya, who brings a decade across think tanks, startups, listed companies, and promoter-led conglomerates in both countries.
                  </p>
                  {/* <h6 className="pt-[5px] font-neue font-[400] text-[24px] lg:text-[36px] leading-[34px] lg:leading-[39px] text-[#0F3460] ">
                    We are not a consultancy. We are not a fund.
                    <span className="text-[#BB872A]"></span>
                  </h6>
                  <p className="font-[400] font-neue text-[14px] lg:text-[16px] leading-[22px] lg:leading-[22px] tracking-[-0.22px] text-[#05003E] pb-[30px] lg:pb-[30px] mt-[10px]">
                    IndUS Tech is a platform built to align people, capital, and policy decisions that move the corridor forward.
                    Our role is defined by outcomes, not labels.
                  </p> */}


                  <div
                    className="flex flex-col sm:flex-row gap-[12px] w-full lg:w-auto mt-2"
                    data-aos="zoom-in"
                    data-aos-delay="400"
                  >

                    <Link to="/what-we-do">
                      <button
                        style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                        className="py-[10px] lg:py-[12px] px-[15px] w-full sm:w-auto transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[13px] lg:text-[14px] leading-[20px] text-center text-white"
                      >
                        Explore What We Do
                      </button>
                    </Link>

                    <Link to="/subscription">
                      <button
                        style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                        className="py-[10px] lg:py-[12px] px-[15px] w-full sm:w-auto transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[13px] lg:text-[14px] leading-[20px] text-center text-white"
                      >
                        Subscribe to DOT Weekly
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div
            // className="max-w-[1440px] w-full overflow-hidden mx-auto lg:px-[70px] px-[20px] flex flex-col items-start lg:pb-[30px] pb-[30px]"
            className="max-w-[1440px] w-full overflow-hidden mx-auto px-[20px] sm:px-[30px] md:px-[50px] lg:px-[80px] flex flex-col items-start pb-[40px] sm:pb-[50px] lg:pb-[60px]"
          >
            {/* <p
            data-aos="fade-down"
            className="py-[2px] px-[8px] bg-[#0F3460] font-neue font-[400] text-[12px] leading-[12px] tracking-[1.44px] uppercase text-[#FFFFFF]"
          >
            WHAT WE DO
          </p> */}

            <div className='btn-header'>
              <p>     What We Do</p>
            </div>
            <h6
              data-aos="fade-up"
              data-aos-delay="150"
              className=" pb-[0px] font-neue font-[400] text-[28px] md:text-[36px] leading-[40px] md:leading-[52px] text-[#0F3460] text-left mt-[10px]"
            >
              We advise across four areas.
            </h6>

            {/* <p
              data-aos="fade-up"
              data-aos-delay="300"
              className="font-[400] font-neue text-[14px] md:text-[16px] leading-[24px] md:leading-[32px] tracking-[-0.22px] text-[#05003E] pb-[0px] md:pb-[0px] text-left"
            >
              Our work is designed for fit, timing, and momentum, where capital, capability, and strategy meet.
            </p> */}
            {/* 
          <div className="whatwedo-boxs mt-[0px]">
            <section className="whatwedo-section grid grid-cols-1 md:grid-cols-2 gap-[20px]">

              <div data-aos="zoom-in" data-aos-delay="0" className="whatwedo-box">
                <div className="whatwedo-box-overlay">
                  <h3>Strategic Matchmaking</h3>
                  <p className="text-justify">
                    We curate relationships across founders, funds, decisionmakers, and primes 
                    aligning only when there’s deep strategic fit. Every introduction is intentional.
                    Every pairing, high-trust. Every deal, mission-oriented.
                  </p>
                </div>
              </div>

              <div data-aos="zoom-in" data-aos-delay="150" className="whatwedo-box whatwedo-box2">
                <div className="whatwedo-box-overlay">
                  <h3>Corridor Design</h3>
                  <p className="text-justify">
                    We help build cross-border pathways  from market entry and licensing to dual-use structuring 
                    using the frameworks that already exist.
                  </p>
                </div>
              </div>

              <div data-aos="zoom-in" data-aos-delay="300" className="whatwedo-box whatwedo-box3">
                <div className="whatwedo-box-overlay">
                  <h3>Narrative & Presence</h3>
                  <p className="text-justify">
                    We shape strategic visibility  placing the right stories in the right rooms.
                    Not just attention  position. We convene behind closed doors  saloons, not stages.
                  </p>
                </div>
              </div>

              <div data-aos="zoom-in" data-aos-delay="450" className="whatwedo-box whatwedo-box4">
                <div className="whatwedo-box-overlay">
                  <h3>Execution (via Partners)</h3>
                  <p className="text-justify">
                    Through trusted collaborators, we structure capital and navigate complexity.
                    We engage selectively  via retainers, equity, or outcomes.
                  </p>
                </div>
              </div>

            </section>
          </div> */}
          </div>
        </section>

        <div className='lg:px-[70px] px-[20px] max-w-[1440px] mx-auto'>
          <div className='new-wedo-boxs'>
            <div className='new-wedo-box'>
              {/* <img src='./assets/home/s1.jpg' alt='' /> */}
              <img src='./assets/home/defence1.jpeg' alt='' />
              <div className='new-wedo-box-text'>
                <h3>Market entry and structure</h3>
                <p>
                  We advise companies on how to enter a new market and how to structure the business. That includes the entity, ownership, governance, and required approvals. Once the company is operating, we stay on as its advisor.
                </p>
              </div>
            </div>
            <div className='new-wedo-box'>
              {/* <img src='./assets/home/s2.jpg' alt='' /> */}
              <img src='./assets/home/defence2.jpeg' alt='' />
              <div className='new-wedo-box-text'>
                <h3>Regulatory strategy</h3>
                <p>
                  ITAR and other export controls, CFIUS, foreign-ownership limits, DAP, and SCOMET define what is possible in this sector. We address these questions before a deal takes shape and conduct diligence on the counterparties our clients are considering, working closely with specialist counsel.
                </p>
              </div>
            </div>
            <div className='new-wedo-box'>
              {/* <img src='./assets/home/s3' alt='' /> */}
              <img src='./assets/home/defence3.jpeg' alt='' />
              <div className='new-wedo-box-text'>
                <h3>Commercial and partnership strategy</h3>
                <p>
                  We help companies determine where their product fits, who the buyer is, which partnership model will make them competitive, and when to move. We also build the commercial case that lenders and investors need to see.
                </p>
              </div>
            </div>
            <div className='new-wedo-box'>
              {/* <img src='./assets/home/2151917417.jpg' alt='' /> */}
              <img src='./assets/home/defence4.jpeg' alt='' />
              <div className='new-wedo-box-text'>
                <h3>
                  Sector intelligence
                </h3>
                <p>
                  Our weekly tracking of deals, procurement, and policy across both markets informs our advice. Clients see shifts in the market early and act on them first. DOT Weekly, our public brief, is drawn from that work.
                </p>
              </div>
            </div>




          </div>
        </div>

        <br />
        <br />
        <br />
        <br />
      </div>

      {/* <section className="relative overflow-hidden">
                <img
                    src="/assets/home/sig.jpg"
                    className="h-[650px] md:h-[500px] lg:h-[623px] w-full object-cover"
                    alt=""
                />
                <div className="absolute inset-0 bg-[#001E42]/50"></div>
                <div className="absolute right-[-150px] md:right-[-250px] lg:right-[-330px] bottom-0">
                    <img src="/assets/home/wrapper.svg" alt="" />
                </div>
                <div className="max-w-[1440px] w-full mx-auto absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2  py-[40px] lg:py-[60px] lg:px-[70px] px-[20px]">
                    <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-[30px]">
                        <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
                            <p className="py-[2px] px-[8px] bg-[#0F3460] font-neue font-[400] text-[12px] leading-[12px] tracking-[1.44px] uppercase text-white">
                                The Corridor
                            </p>
                            <h6 className="pt-[12px] pb-[0px] font-neue font-[400] text-[24px] md:text-[30px] lg:text-[36px] leading-[32px] md:leading-[40px] lg:leading-[40px] text-white max-w-[370px] w-full">
                                This is where we think{" "}aloud quietly.  <br/>Briefs & Reports
                                <span className="text-[#BB872A]"></span>
                            </h6>


                            
                    <div className='line mt-[5px]'></div>
                            
                            <p style={{marginTop:'10px'}} className="font-[400] font-neue max-w-[485px] w-full text-[14px] md:text-[16px] leading-[24px] md:leading-[29px] tracking-[-0.22px] text-white pb-[20px]">
                                We occasionally publish white papers.
                                When we do, they’re listed here and only when they move the conversation forward

                            </p>
                        </div>
                        <div className="lg:pr-[40px] flex justify-center">
                            <img
                                src="/assets/home/flag.avif"
                                style={{ borderRadius: '50px' }}
                                className="max-w-[250px] md:max-w-[350px] lg:max-w-[450px] w-full h-auto"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </section> */}
      {/* <section className="overflow-hidden relative ">
        <img
          src="/assets/home/newstock.jpg"
          className="h-[400px] object-cover w-full"
          alt=""
        />

        <div
          className=" absolute inset-0 flex items-center justify-start p-[20px] max-w-[1440px] mx-auto lg:px-[70px]"
          data-aos="fade-right"
        >
          <div
            className="w-full max-w-[729px] flex flex-col items-start bg-white rounded-[20px] lg:rounded-[30px] p-[20px] lg:p-[50px]"
            style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className='btn-header'>
                    <p>  Our Network</p>
                        </div>
            <p
              className="py-[2px] px-[8px] bg-[#0F3460] font-neue font-[400] text-[12px] leading-[12px] tracking-[1.44px] uppercase text-white"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              Our Network
            </p>

            <h6
              className="pt-[10px] pb-[5px] lg:pt-[10px] lg:pb-[5px] font-neue font-[400] 
        text-[24px] lg:text-[36px] leading-[32px] lg:leading-[35px] text-[#0F3460] max-w-full w-full"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              We don’t scale through volume. We scale through alignment.
              <span className="text-[#BB872A]"> </span>
            </h6>

            <div className="line mt-[10px]" data-aos="fade-up" data-aos-delay="600"></div>
        

            <p
              className="font-[400] font-neue max-w-full w-full text-justify text-[14px] lg:text-[16px] leading-[24px] lg:leading-[20px] tracking-[-0.22px] text-[#0D1220]  mt-[10px]"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              Our work depends on trust. We collaborate only with those who match our
              pace, precision, and principles. Our partners span capital, execution,
              policy, and domain expertise — selectively activated, 
              <span className="text-[#0F3460] font-neue italic" style={{ fontWeight: 800 }}> challenge by challenge, deal by deal.
              </span>
            </p>
          </div>
        </div>
      </section> */}
      <div className='overflow-hidden'>
        <ParallaxSection />
      </div>
      {/* <section
        className="pt-[50px] overflow-hidden lg:pt-[50px] lg:pl-[100px] pl-[20px] pb-[50px] relative "
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <div
          className="absolute bottom-0 left-0 w-full h-[100px] pointer-events-none"
          style={{
            background:
              "linear-gradient(0deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)",
          }}
        ></div>

        <div
          className="flex flex-col lg:flex-row items-start max-w-[1440px] w-full mx-auto lg:gap-[118px] gap-[30px] relative"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div
            className="flex flex-col items-start max-w-full lg:max-w-[155px] w-full px-[10px] lg:px-0"
            data-aos="fade-right"
            data-aos-delay="300"
          >
            <h6
              className="pt-[8px] pb-[5px] lg:pb-[5px] font-neue font-[400] text-[24px] lg:text-[36px] leading-[36px] lg:leading-[52px] text-[#0E3364]"
            >
              Briefs & Reports<span className="text-[#BB872A]"></span>
            </h6>

            <div
              className="line"
              data-aos="zoom-in"
              data-aos-delay="400"
            ></div>
          </div>

          <div
            className="overflow-hidden relative briefs-slider w-full px-[10px] lg:px-0"
          >
            <ReportSlider />
          </div>
        </div>

        
      </section> */}
      <div
        // className='newletters-div bg-[#FFFFFF] overflow-hidden px-[20px] lg:px-[100px]'
        className='newletters-div bg-[#FFFFFF] overflow-hidden px-[20px] sm:px-[30px] md:px-[60px] lg:px-[100px] pt-[60px] sm:pt-[80px] lg:pt-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]'
      >
        <NewsLetter />
      </div>
    </>
  )
}

export default Home